// extracted by mini-css-extract-plugin
export default {"div":"Pages_div__KR0Q7","Integrationsdiv":"Pages_Integrationsdiv__KClDs","Integrationslogodiv":"Pages_Integrationslogodiv__H6IMS"};